// extracted by mini-css-extract-plugin
module.exports = {"datePicker":"Datepicker_datePicker__BQrcY","fieldLabel":"Datepicker_fieldLabel__YNs9Z","borderVisible":"Datepicker_borderVisible__3hn4X"};